import React, { forwardRef } from "react";

export const InputField = forwardRef(
  (
    {
      label,
      name,
      type = "text",
      value,
      onChange,
      required = false,
      placeholder,
      disabled,
      options,
      defaultOptionLabel = "Pilih...",
      error,
      labelColor = "text-white",
      accept,
      rows = 4,
      style,
      startIcon,
      labelClassName = "", // tambahkan default
      onKeyDown,
      autoComplete,
    },
    ref
  ) => {
    const hideLabel = labelClassName.includes("sr-only");

    return (
      <div
        className={`w-full ${
          hideLabel ? "flex items-center" : "flex flex-col"
        }`}
      >
        {label && (
          <label
            htmlFor={name}
            className={`${labelColor} mb-2 ${labelClassName} ${
              hideLabel ? "mb-0" : ""
            }`}
          >
            {label} {required && "*"}
          </label>
        )}

        {type === "select" ? (
          <select
            name={name}
            id={name}
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            ref={ref}
            aria-describedby={error ? `${name}-error` : undefined}
            className={`input w-full pl-4 pr-6 py-2 h-[42px] border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 ${
              error ? "border-red-500" : "border-gray-300"
            }`}
          >
            <option value="" disabled>
              {defaultOptionLabel}
            </option>
            {options?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ) : type === "file" ? (
          <input
            type="file"
            name={name}
            id={name}
            onChange={onChange}
            required={required}
            disabled={disabled}
            accept={accept}
            ref={ref}
            aria-describedby={error ? `${name}-error` : undefined}
            className={`input w-full h-[42px] pl-3 pr-6 py-1 border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 file:mr-4 file:py-1 file:px-4 file:rounded-lg file:border-0 file:bg-slate-200 file:text-slate-900 hover:file:bg-slate-700 hover:file:text-white ${
              error ? "border-red-500" : "border-gray-300"
            }`}
          />
        ) : type === "textarea" ? (
          <textarea
            name={name}
            id={name}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            disabled={disabled}
            rows={rows}
            style={style}
            ref={ref}
            aria-describedby={error ? `${name}-error` : undefined}
            className={`input w-full pl-3 pr-6 py-2 border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 resize-y ${
              error ? "border-red-500" : "border-gray-300"
            }`}
          />
        ) : (
          <div className="relative w-full">
            {startIcon && (
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                {startIcon}
              </span>
            )}
            <input
              type={type}
              name={name}
              id={name}
              value={value}
              onChange={onChange}
              required={required}
              placeholder={placeholder}
              disabled={disabled}
              ref={ref}
              onKeyDown={onKeyDown}
              autoComplete={autoComplete}
              aria-describedby={error ? `${name}-error` : undefined}
              className={`input w-full ${
                startIcon ? "pl-10" : "pl-3"
              } pr-6 py-2 h-[42px] border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 ${
                error ? "border-red-500" : "border-gray-300"
              }`}
            />
          </div>
        )}

        {error && (
          <p id={`${name}-error`} className="text-red-500 text-sm mt-1">
            {error}
          </p>
        )}
      </div>
    );
  }
);

InputField.displayName = "InputField";
